export default "__VITE_ASSET__C8cJYp5A__"